"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * @author Radim Krkoška
 */


var SiteFormatChange =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SiteFormatChange, _DomainObject_1$Domai);

  /**
   * @param id the internal id
   * @param siteId
   * @param oldFormatId
   * @param newFormatId
   * @param validFrom
   * @param optEngineUpdateTime
   */
  function SiteFormatChange(id, siteId, oldFormatId, newFormatId, validFrom, optEngineUpdateTime) {
    var _this;

    _classCallCheck(this, SiteFormatChange);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SiteFormatChange).call(this));
    _this.id = id;
    _this.siteId = siteId;
    _this.oldFormatId = oldFormatId;
    _this.newFormatId = newFormatId;
    _this.validFrom = validFrom;
    _this.optEngineUpdateTime = optEngineUpdateTime;
    return _this;
  }

  return SiteFormatChange;
}(DomainObject_1.DomainObject);

exports.SiteFormatChange = SiteFormatChange;
/**
 * data schema
 */

SiteFormatChange.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SiteFormatChange.name);
  return {
    id: builder.id('id'),
    siteId: builder.str('siteId'),
    oldFormatId: builder.str('oldFormatId'),
    newFormatId: builder.str('newFormatId'),
    validFrom: builder.date('validFrom'),
    optEngineUpdateTime: builder.opt(builder.date('optEngineUpdateTime'))
  };
}();